import api from '../auth';
const slug = 'api/pkgps/';

const PkgpService = () => {
    const getPkgps = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getPkgpsLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getPkgp = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deletePkgp = (id) => {
        return api
            .delete(slug + `pkgp/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createPkgp = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updatePkgp = (id, data) => {
        return api.put(slug + `pkgp/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyPkgp = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    const startPkgp = (data) => {
        return api.post(slug + `start/`, data).then((res) => res.data);
    };

    const endPkgp = (data) => {
        return api.post(slug + `end/`, data).then((res) => res.data);
    };

    const pdfPkgp = (id) => {
        return api
            .get(slug + `pdf/${id}/`, {
                responseType: 'blob'
            })
            .then((res) => {
                // Try custom exposed header first
                let filename = res.headers['x-filename'];
                if (!filename) {
                    const disposition = res.headers['content-disposition'] || res.headers['Content-Disposition'];
                    filename = 'pkgp.pdf';
                    if (disposition) {
                        const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition);
                        if (match) {
                            try {
                                filename = decodeURIComponent(match[1] || match[2]);
                            } catch (e) {
                                filename = match[1] || match[2];
                            }
                        }
                    }
                }
                return { blob: res.data, filename };
            });
    };

    // uploadSignatureImage
    const uploadSignatureImage = (id, data) => {
        return api
            .post(slug + `${id}/upload-signature-image`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((res) => res.data);
    };

    const nijeKodKuce = (id, geoData = {}) => {
        return api.post(slug + 'nije-kod-kuce', { id, ...geoData }).then((res) => res.data);
    };

    // exportExcel - export filtered results to Excel
    const exportExcel = (params) => {
        return api
            .get(slug + 'export-excel', {
                params,
                responseType: 'blob'
            })
            .then((res) => {
                let filename = res.headers['x-filename'] || 'pkgp_export.xlsx';
                const disposition = res.headers['content-disposition'] || res.headers['Content-Disposition'];
                if (disposition) {
                    const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition);
                    if (match) {
                        try {
                            filename = decodeURIComponent(match[1] || match[2]);
                        } catch (e) {
                            filename = match[1] || match[2];
                        }
                    }
                }
                return { blob: res.data, filename };
            });
    };

    return {
        getPkgps,
        getPkgpsLazy,
        getPkgp,
        deletePkgp,
        createPkgp,
        updatePkgp,
        getOptions,
        copyPkgp,
        startPkgp,
        endPkgp,
        pdfPkgp,
        uploadSignatureImage,
        exportExcel,
        nijeKodKuce
    };
};

export default PkgpService;
